import * as React from "react";
import { Icon } from "../Icon/icon";
import {
  IDesktopLanguagePickerProps,
  IDesktopLanguagePickerState,
} from "./IDesktopLanguagePickerState.types";

export class DesktopLanguagePicker extends React.Component<
  IDesktopLanguagePickerProps,
  IDesktopLanguagePickerState
> {
  constructor(props: IDesktopLanguagePickerProps) {
    super(props);
    this.state = {
      hideLanguage: false,
    };
  }

  showLanguages = () =>
    this.setState((state) => ({
      hideLanguage: !state.hideLanguage,
    }));

  render() {
    const showClass = this.state.hideLanguage
      ? "languagepicker languagepicker--show"
      : "languagepicker";
    return (
      <div>
        <button
          className="functionlink"
          type="button"
          onClick={this.showLanguages}
        >
          <Icon iconType="fontawesome/globe-europe" />
          <span className="functionlink__text">Language</span>
        </button>

        <div className={showClass}>
          <div className="languagepicker__heading">Change language</div>
          <ul>
            {(this.props.translatedItems || []).map((lang) => (
              <li key={lang.Value}>
                <a href={lang.Value}>Go to {lang.Text}</a>
              </li>
            ))}
            {(this.props.translatedStartPageItems || []).map((lang) => (
              <li key={lang.Value}>
                <a href={lang.Value}>Go to {lang.Text} startpage</a>{" "}
              </li>
            ))}
            {this.props.minorityLanguages.map((lang) => (
              <li key={lang.Value}>
                <a href={lang.Value}>Go to {lang.Text}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}
